import React, { useContext } from 'react';
import { ShoppingCartContext } from '../../Providers/ShoppingCartProvider/ShoppingCartProvider';
import Product from './Product';
import Overlay from '../../UX/Overlay/Overlay';
import { TranslationContext } from '../../Providers/TranslationProvider';

const Products = () => {
    const { products, loading } = useContext(ShoppingCartContext);
    const { trans } = useContext(TranslationContext);

    const Products = products
        .reverse()
        .map(p => <Product key={p.hash} product={p} />);

    return (
        <>
            <Overlay show={loading} message={trans('updating_cart', true)} />
            {Products}
        </>
    );
};

export default Products;
